function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import styled, { css } from "styled-components";
import React, { memo, useRef } from "react";
import useClickAway from "react-use/lib/useClickAway";
import Panel from "../../Layout/Panel";
import { setContent, useContent } from "./state/content";
const aligns = {
  "top left": css(["transform:translateX(0);"]),
  "top right": css(["transform:translateX(-100%);"]),
  "bottom left": css(["transform:translateY(-100%);"]),
  "bottom right": css(["transform:translate(-100%,-100%);"])
};
const Root = /*#__PURE__*/styled(Panel).withConfig({
  displayName: "Root",
  componentId: "sc-1l8r79o-0"
})(["", " position:fixed;z-index:10;top:", "px;left:", "px;"], ({
  align
}) => aligns[align], ({
  y
}) => y, ({
  x
}) => x);
const Popup = /*#__PURE__*/memo(() => {
  const ref = useRef();
  const content = useContent();
  useClickAway(ref, () => setContent());
  if (!content) return false;
  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref
  }, content));
});
Popup.displayName = "Popup";
export default Popup;
//# sourceMappingURL=Popup.js.map